import * as React from "react";
import { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import EditIcon from "@mui/icons-material/Edit";
import baseUrl from "../../../../BaseURL";
import LoanApplicationProfilePreview from "../FormProcess/Forms/loan/LoanApplicationProfilePreview";
import ViewRejectMsg from "./ViewRejectMsg";

export default function ViewDocDialoug({docname, filePath,token,filetoken ,from}) {


    const [open, setOpen] = useState(false);
    
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const isPdf = filePath.toLowerCase().endsWith(".pdf");
    const isImage = /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filePath);

    







    return (
        <div className="appicant-profile-dialog-con font-mono">
            <Button
                variant="contained"
                onClick={handleClickOpen}
                sx={{ backgroundColor: "green" }}
                startIcon={<EditIcon />}
            >
                {from === "viewdoc" ? "View Document" : "View Rejection"}
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={ from === "viewdoc" ? "" : "sm"}
                fullWidth
            >

              {
                from === "viewdoc" &&
                   <DialogContent style={{ textAlign: "center",display:"flex",gap:"10px",justifyContent:"center", position:"relative" }}>

                      <h1 className="text-center absolute left-9 font-extrabold text-xl">{docname}</h1>
                   <div className="w-[50%] h-[100%] sticky top-9">
                     
                      <div className="h-[100%] ">
                          {isPdf ? (
                        <iframe
                            src={`${baseUrl}/get_doc/${filePath}`}
                            style={{ width: "100%", height: "80vh", border: "none" }}
                        />
                    ) : isImage ? (
                        <img
                            src={`${baseUrl}/get_doc/${filePath}`}
                            alt="Document Preview"
                            style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }}
                        />
                    ) : (
                        <p>Unsupported file format</p>
                    )}
                      </div>
                   </div>

                     <div className="w-[50%] h-[100%]">
                        
                        <LoanApplicationProfilePreview applicanttoken={token} from="viewdoc" file_token={filetoken} />
                        
                     </div>



                </DialogContent>
              }

                { from === "viewrejtmsg" &&


                <DialogContent style={{ textAlign: "center",display:"flex",gap:"10px",justifyContent:"center", position:"relative" }}>


               <ViewRejectMsg applicant_token={token} document_token={filetoken} />



                </DialogContent>


                }

                <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
